import { QueryClient } from '@tanstack/react-query'

function isServerUnavailable(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  return (
    'isServerUnavailable' in error &&
    (error as { isServerUnavailable: boolean }).isServerUnavailable
  )
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error) => {
        // バックエンド未起動（5xx・ネットワークエラー）は最大10回リトライ
        if (isServerUnavailable(error)) return failureCount < 10
        // それ以外（4xx など）は1回のみ
        return failureCount < 1
      },
      retryDelay: (failureCount, error) => {
        // バックエンド未起動は2秒固定
        if (isServerUnavailable(error)) return 2000
        // それ以外はデフォルト指数バックオフ
        return Math.min(1000 * 2 ** failureCount, 30000)
      },
      refetchOnWindowFocus: false,
    },
  },
})
